import type { WorkflowBlock } from './types';

export const WORKFLOW_BLOCKS: WorkflowBlock[] = [
  // Triggers
  {
    id: 'trigger-employee-created',
    type: 'trigger',
    category: 'Triggers',
    label: 'Employee Created',
    description: 'Runs when a new employee is added',
    blockKey: 'employee-created',
  },
  {
    id: 'trigger-employee-updated',
    type: 'trigger',
    category: 'Triggers',
    label: 'Employee Updated',
    description: 'Runs when employee details change',
    blockKey: 'employee-updated',
  },
  {
    id: 'trigger-payroll-generated',
    type: 'trigger',
    category: 'Triggers',
    label: 'Payroll Generated',
    description: 'Runs when payroll run completes',
    blockKey: 'payroll-generated',
  },
  {
    id: 'trigger-payroll-finalized',
    type: 'trigger',
    category: 'Triggers',
    label: 'Payroll Finalized',
    description: 'Runs when payroll is finalized',
    blockKey: 'payroll-finalized',
  },
  {
    id: 'trigger-scheduled',
    type: 'trigger',
    category: 'Triggers',
    label: 'Scheduled Trigger',
    description: 'Runs on a schedule you choose',
    blockKey: 'scheduled',
  },
  {
    id: 'trigger-manual',
    type: 'trigger',
    category: 'Triggers',
    label: 'Manual Test Trigger',
    description: 'Run this workflow manually with test data',
    blockKey: 'manual-test',
  },
  // Conditions
  {
    id: 'condition-if',
    type: 'condition',
    category: 'Conditions',
    label: 'If Condition',
    description: 'Check a field against a value',
    blockKey: 'if-condition',
  },
  {
    id: 'condition-salary-threshold',
    type: 'condition',
    category: 'Conditions',
    label: 'Salary Change Above Threshold',
    description: 'Check if salary variance exceeds a percentage',
    blockKey: 'salary-threshold',
  },
  // Actions
  {
    id: 'action-send-email',
    type: 'action',
    category: 'Actions',
    label: 'Send Email',
    description: 'Send an email to a recipient',
    blockKey: 'send-email',
  },
  {
    id: 'action-send-notification',
    type: 'action',
    category: 'Actions',
    label: 'Send Notification',
    description: 'Send an in-app notification',
    blockKey: 'send-notification',
  },
  {
    id: 'action-create-task',
    type: 'action',
    category: 'Actions',
    label: 'Create Task',
    description: 'Create a task for someone to complete',
    blockKey: 'create-task',
  },
  {
    id: 'action-generate-report',
    type: 'action',
    category: 'Actions',
    label: 'Generate Report',
    description: 'Generate and optionally send a report',
    blockKey: 'generate-report',
  },
  {
    id: 'action-data-loader',
    type: 'action',
    category: 'Actions',
    label: 'Data Loader',
    description: 'Prepare or load data to send into the workflow',
    blockKey: 'data-loader',
  },
  // AI Steps
  {
    id: 'ai-summary',
    type: 'ai',
    category: 'AI Steps',
    label: 'Generate AI Summary',
    description: 'Use AI to summarize or analyze data',
    blockKey: 'generate-ai-summary',
  },
  // Flow control
  {
    id: 'flow-end',
    type: 'end',
    category: 'Flow',
    label: 'End',
    description: 'Marks the end of the workflow',
    blockKey: 'end',
  },
];

export const NODE_WIDTH = 220;
export const NODE_HEIGHT = 72;
export const VERTICAL_GAP = 48;
